import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  List,
  ListItem,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import React, { useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoCloseSharp } from "react-icons/io5";
import { NAVBAR_LINKS } from "../utils";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useCurrentLocation from "../hooks/useCurrentLocation";
import { getActiveTab } from "../utils";

const Header = () => {
  const { isHomePage, currentPath } = useCurrentLocation();
  const navigate = useNavigate();

  const fadeInOut = keyframes`0% {
        opacity: 0;
      }
      25% {
        opacity: 0.25;
      }
      50% {
          opacity: 0.5;
        }
        75% {
        opacity: 0.75;
    }
    100% {
          ḍopacity: 1;
      }`;

  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const [isLargerThan1280] = useMediaQuery("(min-width: 1280px)");

  const MobileDrawer = ({ isOpen, onClose }) => {
    return (
      <Drawer
        isOpen={isOpen}
        placement="right"
        closeOnEsc={true}
        onClose={onClose}
      >
        <DrawerContent bg="#2b2b2c">
          <Button
            pos="absolute"
            top="1%"
            right="1%"
            fontSize="2rem"
            onClick={onClose}
          >
            <IoCloseSharp />
          </Button>
          <DrawerBody mx="auto">
            <List display="flex" flexDir="column" mt="12">
              {NAVBAR_LINKS.map((item) => {
                return (
                  <ListItem key={item.title} pb="3">
                    <Button
                      variant="primary"
                      _hover={{ fontWeight: "600" }}
                      color={
                        getActiveTab(currentPath) === item.title
                          ? "tertiaryColor"
                          : "#fff"
                      }
                    >
                      {isHomePage ? (
                        <Link
                          to={item.to}
                          duration={item.duration}
                          smooth={true}
                          onClick={onClose}
                        >
                          {item.title}
                        </Link>
                      ) : (
                        <RouterLink to={item.link} onClick={onClose}>
                          {item.title}
                        </RouterLink>
                      )}
                    </Button>
                  </ListItem>
                );
              })}
            </List>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  };

  return (
    <Box
      pos={isHomePage ? "absolute" : "relative"}
      top="0"
      left="0"
      h="auto"
      w="100%"
      display="flex"
      alignItems="center"
      justifyContent={{ base: "space-between", xl: "flex-start" }}
      overflowX="hidden"
      zIndex={1}
    >
      {/* home button */}
      <Box w={{ base: "80%", xl: "30%" }}>
        <Button
          variant="primary"
          isActive={getActiveTab(currentPath) === "Home"}
          onClick={() => {
            !isHomePage && navigate("/");
          }}
        >
          <FaChevronRight />
          &nbsp; Home
          <Text
            as="span"
            animation={`${fadeInOut} 1.5s infinite`}
            transition="all 0.3s linear"
          >
            _
          </Text>
        </Button>
      </Box>

      {/* navbar */}
      {isLargerThan1280 ? (
        <Box
          w={{ base: "auto", xl: "85%", xxl: "70%" }}
          bg="#2b2b2cbf"
          p="0 20px"
          borderRadius="0 0 0 20px"
          border="1px solid #383838"
          backdropBlur="10px"
        >
          <List
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p="10px 7px"
          >
            {NAVBAR_LINKS.map((item) => {
              return (
                <ListItem key={item.link} px="0rem">
                  <Button
                    variant="primary"
                    padding="0"
                    w="auto"
                    minW="auto"
                    _hover={{ color: "tertiaryColor" }}
                    color={
                      getActiveTab(currentPath) === item.title
                        ? "tertiaryColor"
                        : "#fff"
                    }
                  >
                    {isHomePage ? (
                      <Link to={item.to} duration={item.duration} smooth={true}>
                        {item.title}
                      </Link>
                    ) : (
                      <RouterLink to={item.link}>{item.title}</RouterLink>
                    )}
                  </Button>
                </ListItem>
              );
            })}
          </List>
        </Box>
      ) : (
        <Box w="auto" p="20px 7px">
          <Button
            variant="primary"
            fontSize="2rem"
            onClick={() => setIsOpen(true)}
          >
            <GiHamburgerMenu />
          </Button>
          <MobileDrawer isOpen={isOpen} onClose={onClose} />
        </Box>
      )}
    </Box>
  );
};

export default Header;
